import { useMutation } from '@tanstack/react-query';
import { AppApiV2, ImageUploadResultDto } from '../../../../lib/api/app/AppApiV2';
import { ErrorResponseType, extractErrorMessage } from '../../../../lib/utils/checkErrorResponse';
import toastMsg from '../../../../lib/toastMsg';
import { Attachment } from '../types';
import appToastMsg from '../../../../constants/service/toastMsg/appToastMsg';

const useImageUploadMutate = (uploadSuccessAttachment: (data: Attachment, index: number) => void) => {
  const imageUploadSuccess = (
    { imageUrl, width, height }: ImageUploadResultDto,
    { index }: { file: File; index: number },
  ) => {
    const data = {
      url: imageUrl,
      width,
      height,
    };

    toastMsg.success(appToastMsg.ADD_TEMP_IMG_REQUEST_SUCCESS);
    uploadSuccessAttachment(data, index);
  };

  const { mutate: squareImageUploadMutate } = useMutation(
    async (payload: { file: File; index: number }) => AppApiV2.uploadsSquareImage(payload.file),
    {
      onSuccess: imageUploadSuccess,
      onError: (error) => {
        toastMsg.error(extractErrorMessage(error as ErrorResponseType));
      },
    },
  );

  const { mutate: rectangleImageUploadMutate } = useMutation(
    async (payload: { file: File; index: number }) => AppApiV2.uploadsRectangleImage(payload.file),
    {
      onSuccess: imageUploadSuccess,
      onError: (error) => {
        toastMsg.error(extractErrorMessage(error as ErrorResponseType));
      },
    },
  );

  return {
    squareImageUploadMutate,
    rectangleImageUploadMutate,
  };
};

export default useImageUploadMutate;
